import React from 'react';
import { X, Calendar, Building, User } from 'lucide-react';
import Button from '../../../components/ui/Button';


const DocumentFilterPanel = ({ filters, setFilters, employees, onClose }) => {
  const departments = [...new Set(employees?.map(emp => emp?.department)?.filter(Boolean))];

  const handleReset = () => {
    setFilters({
      category: null,
      startDate: null,
      endDate: null,
      department: null,
      employeeId: null,
      tags: [],
      includeArchived: false
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Advanced Filters</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Date Range */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar className="w-4 h-4 inline mr-1" />
            Start Date
          </label>
          <input
            type="date"
            value={filters?.startDate || ''}
            onChange={(e) => setFilters(prev => ({ ...prev, startDate: e?.target?.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar className="w-4 h-4 inline mr-1" />
            End Date
          </label>
          <input
            type="date"
            value={filters?.endDate || ''}
            onChange={(e) => setFilters(prev => ({ ...prev, endDate: e?.target?.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          />
        </div>

        {/* Department */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Building className="w-4 h-4 inline mr-1" />
            Department
          </label>
          <select
            value={filters?.department || ''}
            onChange={(e) => setFilters(prev => ({ ...prev, department: e?.target?.value || null }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          >
            <option value="">All Departments</option>
            {departments?.map(dept => (
              <option key={dept} value={dept}>
                {dept}
              </option>
            ))}
          </select>
        </div>

        {/* Employee */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <User className="w-4 h-4 inline mr-1" />
            Employee
          </label>
          <select
            value={filters?.employeeId || ''}
            onChange={(e) => setFilters(prev => ({ ...prev, employeeId: e?.target?.value || null }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          >
            <option value="">All Employees</option>
            {employees?.map(emp => (
              <option key={emp?.id} value={emp?.id}>
                {emp?.firstName} {emp?.lastName} - {emp?.employeeNumber}
              </option>
            ))}
          </select>
        </div>

        {/* Include Archived */}
        <div className="flex items-center">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={filters?.includeArchived}
              onChange={(e) => setFilters(prev => ({ ...prev, includeArchived: e?.target?.checked }))}
              className="w-4 h-4 text-emerald-600 rounded focus:ring-emerald-500"
            />
            <span className="text-sm font-medium text-gray-700">Include Archived</span>
          </label>
        </div>
      </div>

      {/* Actions */}
      <div className="flex items-center justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
        <Button
          onClick={handleReset}
          variant="outline"
          size="sm"
        >
          Reset Filters
        </Button>
        <Button
          onClick={onClose}
          size="sm"
          className="bg-emerald-600 hover:bg-emerald-700 text-white"
        >
          Apply Filters
        </Button>
      </div>
    </div>
  );
};

export default DocumentFilterPanel;